<template>
  <div id="app">
    <div class="dash" :class="showMenu && currentRouteName() != 'selectIntegrador' && currentRouteName() != 'Login' ? '' : 'dash-compact'"  >
      <div class="dash-nav dash-nav-dark" v-show="user && currentRouteName() != 'Login'" :class="currentRouteName() == 'selectIntegrador' ? 'd-none' : ''" >
        <header>
          <button
            type="button"
            class="navbar-toggler menu-toggle"
            @click="showMenu = !showMenu"
          >
            <span class="bi bi-list"></span>
          </button>
          <router-link class="navbar-brand" :to="brandHomeRoute">{{ appName }}</router-link>
        </header>

        <nav class="dash-nav-list">
          <router-link
            v-if="canAccess('DASHBOARD')"
            class="dash-nav-item"
            :class="isActiveRouter('Dashboard')"
            @click.native="handleMenu()"
            to="/"
            >Dashboard</router-link
          >
          <router-link
            v-if="canAccess('USUARIOS')"
            class="dash-nav-item"
            :class="isActiveRouter('Usuarios')"
            @click.native="handleMenu()"
            to="/usuarios"
            >Usuarios</router-link
          >
          <router-link
            v-if="canAccess('INTEGRADORES')"
            class="dash-nav-item"
            :class="isActiveRouter('Integradores')"
            @click.native="handleMenu()"
            to="/integradores"
            >Integradores</router-link
          >
          <router-link
            v-if="canAccess('OPERADORES')"
            class="dash-nav-item"
            :class="isActiveRouter('Operadores')"
            @click.native="handleMenu()"
            to="/operadores"
            >Operadores</router-link
          >
          <router-link
            v-if="canAccess('PRODUCTOS')"
            class="dash-nav-item"
            :class="isActiveRouter('Productos')"
            @click.native="handleMenu()"
            to="/productos"
            >Productos</router-link
          >
          <router-link
            v-if="canAccess('KEYWORDS')"
            class="dash-nav-item"
            :class="isActiveRouter('Keywords')"
            @click.native="handleMenu()"
            to="/keywords"
            >Keywords</router-link
          >
          <router-link
            v-if="canAccess('SERVICIOS')"
            class="dash-nav-item"
            :class="isActiveRouter('Servicios')"
            @click.native="handleMenu()"
            to="/servicios"
            >Servicios</router-link
          >
          <router-link
            v-if="canAccess('BILLING')"
            class="dash-nav-item"
            :class="isActiveRouter('BillingCodes')"
            @click.native="handleMenu()"
            to="/billingcodes"
            >Billing Codes</router-link
          >
          <router-link
            v-if="canAccess('BILLING')"
            class="dash-nav-item"
            :class="isActiveRouter('BillingSequences')"
            @click.native="handleMenu()"
            to="/billingsequences"
            >Billing Sequences</router-link
          >
          <!-- router-link
            v-if="canAccess('REPORTES')"
            class="dash-nav-item"
            :class="isActiveRouter('Tareas')"
            @click.native="handleMenu()"
            to="/tareas"
            >Tareas Bulk</router-link
          -->

        </nav>
      </div>
      <div class="dash-app" :class="currentRouteName() == 'Login' ? 'm-0' : ''">
        <header class="dash-toolbar" v-show="user && currentRouteName() != 'Login'">
          <button
            class="navbar-toggler"
            @click="showMenu = !showMenu"
            type="button"
          >
            <span class="bi bi-list"></span>
          </button>

          <div
            class="tools"
            :style="(canSelectIntegrador || singleIntegradorNombre || isAdmin()) ? 'margin-top: 19px;' : ''"
            :class="currentRouteName() == 'selectIntegrador' ? 'd-none' : ''"
          >
            <div class="row">
              <div
                class="form-group form-inline"
                style="margin-right: 20px"
                v-if="canSelectIntegrador"
                :class="
                  currentRouteName() == 'selectIntegrador' ? 'd-none' : ''
                "
              >
                <label class="d-none d-sm-block" for="navbar_integrador_select"
                  ><b style="margin-right: 10px; color: #515151"
                    >Integrador:
                  </b></label
                >

                <select
                  class="form-control form-control-sm"
                  v-model="integradorSel"
                  name="integrador"
                  aria-label="integrador"
                  id="navbar_integrador_select"
                  @change="onIntegradorChange"
                >
                  <option value="todos">Todos los integradores</option>
                  <template v-if="integradoresList && integradoresList.length">
                    <option
                      v-for="integrador in integradoresList"
                      v-bind:key="integrador.id_integrador || integrador.id"
                      v-bind:value="String(integrador.id_integrador || integrador.id)"
                    >
                      {{ integrador.integrador }}
                    </option>
                  </template>
                </select>
              </div>

              <div
                class="form-group form-inline"
                style="margin-right: 20px"
                v-else-if="singleIntegradorNombre"
                :class="
                  currentRouteName() == 'selectIntegrador' ? 'd-none' : ''
                "
              >
                <label class="mb-0" style="color: #515151;">
                  <b style="margin-right: 6px;">Integrador:</b>
                  <span style="color: #333; font-weight: 600;">{{ singleIntegradorNombre }}</span>
                </label>
              </div>
              <div class="dropdown tools-item">
                <a
                  href="#"
                  class="mr-4"
                  id="dropdownProfileMenu"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <b>{{ user && user.name ? user.name : "" }}</b>
                  <i class="bi bi-person-fill"></i>
                </a>
                <div
                  class="dropdown-menu dropdown-menu-right"
                  aria-labelledby="dropdownProfileMenu"
                >
                  <router-link class="dropdown-item" to="/perfil">Perfil</router-link>
                  <div class="dropdown-divider"></div>
                  <a style="cursor:pointer" class="dropdown-item" @click="logout">Logout</a>
                </div>
              </div>
            </div>
          </div>
        </header>
        <main class="dash-content">
          <div class="container-fluid">
            <router-view :key="$route.fullPath" />
          </div>
        </main>
      </div>
    </div>
    <Spinner />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import Spinner from "./views/Spinner.vue";
import { initNotificationStream, closeNotificationStream } from "./services/notificationService";
import { getDefaultRouteForUser, getUserFromToken } from "./router";

export default {
  components: {
    Spinner,
  },

  data() {
    return {
      showMenu: true,
      integradorSel: localStorage.getItem("integrador") ? String(localStorage.getItem("integrador")) : null,
    };
  },

  created() {
    if (!this.user) {
      const userFromToken = getUserFromToken();
      if (userFromToken) {
        this.$store.commit("auth/setUserData", userFromToken);
        if (userFromToken.integradores) {
          this.$store.commit("integrador/setIntegradores", userFromToken.integradores);
        }
      }
    }
    const stored = localStorage.getItem("integrador");
    if (stored) {
      this.integradorSel = String(stored);
      this.setIntegrador(stored);
    } else {
      const user = this.user || getUserFromToken();
      if (user && user.integradores && user.integradores.length > 0) {
        const firstId = user.integradores[0].id_integrador || user.integradores[0].id;
        this.setIntegrador(firstId);
        this.integradorSel = String(firstId);
      }
    }
    if (localStorage.getItem("authToken")) {
      this.fetchIntegradores();
    }
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    ...mapGetters("integrador", ["integradores"]),
    appName() {
      return process.env.VUE_APP_NAME || "Panel";
    },
    brandHomeRoute() {
      return getDefaultRouteForUser(this.user);
    },
    integradoresList() {
      let list = [];
      if (this.integradores && this.integradores.data && this.integradores.data.length > 0) {
        list = [...this.integradores.data];
      } else if (this.user && this.user.integradores && Array.isArray(this.user.integradores)) {
        list = [...this.user.integradores];
      }
      return list.sort((a, b) =>
        String(a.integrador || "").localeCompare(String(b.integrador || ""), undefined, { sensitivity: "base" })
      );
    },
    canSelectIntegrador() {
      if (this.isAdmin()) {
        return true;
      }
      const count = (this.integradores && this.integradores.data ? this.integradores.data.length : 0) ||
                    (this.user && this.user.integradores ? this.user.integradores.length : 0);
      return count > 0;
    },
    singleIntegradorNombre() {
      if (this.canSelectIntegrador) {
        return null;
      }
      if (this.integradores && this.integradores.data && this.integradores.data.length === 1) {
        return this.integradores.data[0].integrador;
      }
      if (this.user && this.user.integradores && this.user.integradores.length === 1) {
        return this.user.integradores[0].integrador;
      }
      const selId = this.integradorSel || localStorage.getItem("integrador");
      if (selId) {
        if (this.integradores && this.integradores.data) {
          const item = this.integradores.data.find(
            (i) => String(i.id_integrador || i.id) === String(selId)
          );
          if (item && item.integrador) return item.integrador;
        }
        if (this.user && this.user.integradores) {
          const item = this.user.integradores.find(
            (i) => String(i.id_integrador || i.id) === String(selId)
          );
          if (item && item.integrador) return item.integrador;
        }
      }
      return null;
    },
  },

  watch: {
    user(newUser) {
      if (newUser && localStorage.getItem("authToken")) {
        initNotificationStream();
        this.syncIntegradorSel();
        this.fetchIntegradores(true);
      }
    },
    $route(to) {
      this.syncIntegradorSel();
      if (to.name !== "Login" && localStorage.getItem("authToken")) {
        initNotificationStream();
        this.fetchIntegradores(true);
      }
    },
    integradores(newVal) {
      this.syncIntegradorSel();
      if (newVal && newVal.data && newVal.data.length > 0 && !this.integradorSel) {
        const firstId = newVal.data[0].id_integrador || newVal.data[0].id;
        this.setIntegrador(firstId);
        this.integradorSel = String(firstId);
      }
    },
    "$store.state.integrador.integrador"(newVal) {
      if (newVal) {
        this.integradorSel = String(newVal);
      }
    },
  },

  mounted() {
    if (localStorage.getItem("authToken")) {
      this.getUserData();
      this.fetchIntegradores(true);
      initNotificationStream();
    }
  },

  beforeDestroy() {
    closeNotificationStream();
  },

  methods: {
    ...mapActions("auth", ["sendLogoutRequest", "getUserData"]),
    ...mapActions("integrador", ["fetchIntegradores"]),
    ...mapMutations("integrador", ["setIntegrador"]),

    syncIntegradorSel() {
      const stored = localStorage.getItem("integrador");
      if (stored) {
        this.integradorSel = String(stored);
      }
    },

    onIntegradorChange() {
      if (this.integradorSel) {
        this.setIntegrador(this.integradorSel);
        this.redirect();
      }
    },

    redirect() {
      this.syncIntegradorSel();
      if (this.$route.name === "selectIntegrador" || this.$route.name === "Login") {
        const target = getDefaultRouteForUser(this.user);
        this.$router.push(target).catch(() => { this.$router.push("/"); });
      } else {
        window.location.reload();
      }
    },


    async logout() {
      closeNotificationStream();
      await this.sendLogoutRequest();
      if (this.$route.name !== "Login") {
        this.$router.push({ name: "Login" }).catch(() => {});
      }
    },
    handleMenu() {
      if (window.innerWidth < 993) {
        this.showMenu = true;
      }
    },
    isActiveRouter(name) {
      if (name === "Dashboard" && (this.$route.name === "Dashboard" || this.$route.name === "Home" || this.$route.path === "/" || this.$route.path === "/dashboard")) {
        return "active";
      }
      return this.$route.name === name ? "active" : "";
    },
    isAdmin() {
      return this.user && this.user.rol == "admin";
    },
    isApruebaProducto() {
      return this.user && this.user.rol == "apruebaproductos";
    },
    hasPermission(permiso) {
      if (!this.user) return false;
      const perms = this.user.permissions;
      if (!perms) return false;
      if (Array.isArray(perms)) {
        const cleaned = perms.map((p) => String(p).trim().toUpperCase());
        if (cleaned.includes("*") || cleaned.includes("ALL")) return true;
        return cleaned.includes(permiso.toUpperCase());
      }
      return false;
    },
    canAccess(modulo) {
      if (!this.user) return false;
      const mod = String(modulo).toUpperCase();
      switch (mod) {
        case "USUARIOS":
          return this.isAdmin() && this.hasPermission("GEN_USUARIO");
        case "INTEGRADORES":
          return this.isAdmin() && this.hasPermission("GEN_INTEGRADOR");
        case "OPERADORES":
          return this.isAdmin() && this.hasPermission("GEN_OPERADOR");
        case "PRODUCTOS":
          return this.hasPermission("GEN_PRODUCTO");
        case "SERVICIOS":
          return this.hasPermission("GEN_SERVICIO");
        case "BILLING":
          return this.hasPermission("GEN_BILLING");
        case "KEYWORDS":
          return this.hasPermission("GEN_KEYWORD");
        case "REPORTES":
          return this.hasPermission("GEN_REPORTE");
        case "DASHBOARD":
          return this.hasPermission("GEN_DASHBOARD");
        default:
          return false;
      }
    },
    currentRouteName() {
      return this.$route.name;
    },
  },
};
</script>

<style>
body > div > .container {
  padding: 60px 15px 0;
}
.swal2-container {
  z-index: 30000;
}
.dash-nav-dark .dash-nav-item {
  transition: background-color 0.2s ease, border-color 0.2s ease;
}
.dash-nav-dark .dash-nav-item.active,
.dash-nav-dark .dash-nav-item.router-link-exact-active {
  background-color: rgba(255, 255, 255, 0.18) !important;
  color: #ffffff !important;
  font-weight: 700;
  border-left: 4px solid #3498db;
  padding-left: 6px;
}

/* Estilos para ventanas modales arrastrables / movibles */
.modal-header {
  cursor: grab !important;
  user-select: none !important;
}

.modal-header.modal-header-dragging {
  cursor: grabbing !important;
}

.modal-is-dragging {
  user-select: none !important;
}

.modal-mask,
.nested-modal-mask {
  position: fixed !important;
  z-index: 9998;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  min-width: 100vw !important;
  min-height: 100vh !important;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
}

.modal-wrapper {
  display: flex;
  justify-content: center;
  width: 100%;
}

/* Dimensiones globales amplias y cómodas para todas las ventanas modales (altas, edición, etc.) */
.modal-dialog {
  width: 95% !important;
  max-width: 780px !important;
  margin: 1.25rem auto !important;
}

@media (min-width: 576px) {
  .modal-dialog {
    width: 92% !important;
    max-width: 800px !important;
    margin: 1.5rem auto !important;
  }
}

@media (min-width: 992px) {
  .modal-dialog {
    width: 88% !important;
    max-width: 880px !important;
    margin: 1.75rem auto !important;
  }
}

@media (min-width: 1200px) {
  .modal-dialog {
    width: 85% !important;
    max-width: 960px !important;
  }
}

/* Modales Grandes (modal-lg) */
.modal-dialog.modal-lg,
.modal-lg {
  width: 95% !important;
  max-width: 1040px !important;
}

@media (min-width: 992px) {
  .modal-dialog.modal-lg,
  .modal-lg {
    width: 92% !important;
    max-width: 1120px !important;
  }
}

@media (min-width: 1200px) {
  .modal-dialog.modal-lg,
  .modal-lg {
    width: 90% !important;
    max-width: 1200px !important;
  }
}

/* Modales Extra Grandes (modal-xl) */
.modal-dialog.modal-xl,
.modal-xl {
  width: 96% !important;
  max-width: 1350px !important;
}

@media (min-width: 992px) {
  .modal-dialog.modal-xl,
  .modal-xl {
    width: 94% !important;
    max-width: 1450px !important;
  }
}

@media (min-width: 1200px) {
  .modal-dialog.modal-xl,
  .modal-xl {
    width: 92% !important;
    max-width: 1600px !important;
  }
}

/* Modales anidados y scrollables */
.nested-modal-mask,
.modal-mask .modal-mask,
body > div > .nested-modal-mask {
  z-index: 10050 !important;
  background-color: rgba(0, 0, 0, 0.65) !important;
}

.modal-dialog-scrollable .modal-content {
  max-height: 90vh;
}

.modal-dialog-scrollable .modal-body {
  overflow-y: auto !important;
  padding: 1.5rem 1.75rem !important;
}

/* Estilos de ventanas modales redimensionables (Resizable) */
.modal-content,
.modal-container {
  position: relative;
  min-width: 320px;
  min-height: 180px;
  display: flex;
  flex-direction: column;
}

.modal-content .modal-body,
.modal-container .modal-body {
  flex: 1 1 auto;
  overflow-y: auto;
}

.modal-resize-handle {
  position: absolute;
  right: 2px;
  bottom: 2px;
  width: 18px;
  height: 18px;
  cursor: nwse-resize !important;
  z-index: 1000;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  color: #8c9ba5;
  opacity: 0.65;
  transition: opacity 0.2s ease, transform 0.2s ease, color 0.2s ease;
  user-select: none;
}

.modal-resize-handle:hover {
  opacity: 1;
  color: #17a2b8;
  transform: scale(1.18);
}

.modal-is-resizing {
  user-select: none !important;
  cursor: nwse-resize !important;
}
</style>
